module.exports = __webpack_public_path__ + "media/images/crown-b6819acbdc7ecc19f889d5e596cb6d1b.svg";